import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { FranchiseType } from '../types';
import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';

export interface FranchiseFareDataParams extends Omit<FranchiseType, '_id'> {}
export interface PlaceFareDataParams
  extends Omit<FranchiseType, 'localizacao'> {}

interface PostCreateFranchise {
  fareData: FranchiseFareDataParams;
}

const postCreateFranchise = async ({ fareData }: PostCreateFranchise) =>
  apiClient
    .post(`/municipios`, fareData)
    .then(response =>
      handleResponseSuccess(
        response,
        'Tarifa do município criada com sucesso!',
      )(),
    )
    .catch(
      handleResponseThrowError('Não foi possível criar a tarifa do município.'),
    );

export const useCreateFranchise = () => {
  return useMutation({
    mutationFn: postCreateFranchise,
  });
};
